import _ from 'lodash';

const toMarkObject = (value: number) => ({ value, label: '' });

export const MINIMUM_SLIDER_PRICE = 2_500;
export const MAXIMUM_SLIDER_PRICE = 61_000;
const SLIDER_SMALL_STEP_CUTOFF = 10_000;

const marksWithStepOf500 = _.range(MINIMUM_SLIDER_PRICE, SLIDER_SMALL_STEP_CUTOFF, 500).map(toMarkObject);
const marksWithStepOf1000 = _.range(SLIDER_SMALL_STEP_CUTOFF, MAXIMUM_SLIDER_PRICE, 1_000).map(toMarkObject);
const priceRangeSliderMarks = _.concat(marksWithStepOf500, marksWithStepOf1000);

export { priceRangeSliderMarks };
